import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	userRoleFooterText: {
		id: 'feature-gates-tmp-access.feature-gated-roles-picker.footer.user-role-footer-text',
		defaultMessage: 'To customize user roles, upgrade your plan.',
		description:
			'Text shown in the footer of the user roles picker to prompt the user to upgrade their product edition in order to change user roles.',
	},
	learnMore: {
		id: 'feature-gates-tmp-access.feature-gated-roles-picker.footer.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Label for a "learn more" link that takes the user to a documentation page on managing user access for a Jira Software project',
	},
});
